<template>
    <div>
        <p class="label">{{ label }}</p>
        <MultiplePickerInput :value="value" @input="onInput" :items="items" :loading="loading" v-bind="$attrs" />
    </div>
</template>

<script>
  import MultiplePickerInput from '@/components/inputs/MultiplePickerInput.vue';
  import DiplomaService from '@/services/diploma.service.js';

  export default {
    name: "DiplomaMultiplePickerInput",
    components: {
      MultiplePickerInput,
    },
    props: {
      value: Array,
      label: { type: String, default: 'Type(s) diplôme(s)'}
    },
    data: () => ({
      loading: false,
      items: [],
    }),
    created() {
      this.loadListItem();
    },
    methods: {
      loadListItem() {
        const _this = this;

        DiplomaService.getListByStudent().then(({data}) => {
          _this.items = data;
        });
      },
      onInput(event) {
        this.$emit('input', event);
      }
    },
  }
</script>

<style scoped>

</style>
